/**
 * @author Andrés Ferreira
 * @Copyright (c) Infotrack. All rights reserved.
 */
import React from 'react';

import ProveedorEstado from '@infotrack/presentacion-componentes/proveedorEstado';

import FormularioEtapasCV from './controladorVista/formularioEtapasCV';
import TablaEtapasCV from './controladorVista/tablaEtapasCV';
import { estadoIncial, reductor } from './reductorEtapas';

const Etapas: React.FunctionComponent = () => (
    <ProveedorEstado estadoInicial={estadoIncial} reductor={reductor}>
        <TablaEtapasCV />
        <FormularioEtapasCV />
    </ProveedorEstado>
);

export default Etapas;
